/**
 * PrimeVue 5 uses menu item `key` as the DOM id for each row.
 * Duplicate keys (e.g. many items with key: "create") make hover/focus
 * highlight every matching row at once.
 */
export function normalizeMenuModel(items, parentPath = "menu") {
  if (!Array.isArray(items) || items.length === 0) {
    return items;
  }

  const keyCounts = {};
  for (const item of items) {
    if (item == null || item.separator) {
      continue;
    }
    if (item.key != null) {
      const keyStr = String(item.key);
      keyCounts[keyStr] = (keyCounts[keyStr] || 0) + 1;
    }
  }

  return items.map((item, index) =>
    normalizeMenuItem(item, index, parentPath, keyCounts),
  );
}

function normalizeMenuItem(item, index, parentPath, keyCounts) {
  if (item == null) {
    return item;
  }
  if (item.separator) {
    return item;
  }

  const originalKey = item.key;
  const keyStr = originalKey != null ? String(originalKey) : null;
  let domKey;

  if (keyStr && keyCounts[keyStr] > 1) {
    domKey = `${keyStr}-${index}`;
  } else if (keyStr) {
    domKey = keyStr;
  } else {
    domKey = `${parentPath}-${index}`;
  }

  const normalized = {
    ...item,
    key: domKey,
  };

  if (typeof item.command === "function") {
    const originalCommand = item.command;
    normalized.command = (event) => {
      if (originalKey != null && event?.item) {
        event.item = { ...event.item, key: originalKey };
      }
      return originalCommand(event);
    };
  }

  if (Array.isArray(item.items) && item.items.length > 0) {
    normalized.items = normalizeMenuModel(item.items, domKey);
  }

  return normalized;
}
